import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { REGISTRATION_URL } from "../lib/config";

export const GoldButton = ({
  children = "INIZIA GRATIS I 40 GIORNI",
  testId = "cta-gold-button",
  size = "md",
  className = "",
}) => {
  const sizes = {
    sm: "px-6 py-3 text-xs tracking-[0.18em]",
    md: "px-8 py-4 text-sm tracking-[0.16em]",
    lg: "px-10 py-5 sm:px-14 sm:py-6 text-sm sm:text-base tracking-[0.14em]",
  };
  return (
    <motion.a
      href={REGISTRATION_URL}
      data-testid={testId}
      whileHover={{ scale: 1.03 }}
      whileTap={{ scale: 0.97 }}
      transition={{ type: "spring", stiffness: 400, damping: 22 }}
      className={`group relative inline-flex items-center justify-center gap-3 overflow-hidden bg-gold font-display font-bold uppercase text-night ${sizes[size]} ${className}`}
    >
      <span className="absolute inset-0 -translate-x-full bg-ivory transition-transform duration-500 ease-out group-hover:translate-x-0" />
      <span className="relative z-10">{children}</span>
      <ArrowRight className="relative z-10 h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" strokeWidth={2.5} />
    </motion.a>
  );
};
